/** Минимальная длина пароля — как на бэкенде (`Password::defaults()`, AUTH-3). */
export const PASSWORD_MIN_LENGTH = 8;
export const CODE_LENGTH = 6;

export function isValidEmail(value: string): boolean {
  const email = value.trim();
  return email.includes('@') && email.indexOf('@') > 0 && email.indexOf('@') < email.length - 1;
}

export function isValidPassword(value: string): boolean {
  return value.length >= PASSWORD_MIN_LENGTH;
}

/** Оставляет только цифры и режет до 6 — работает и для вставки из буфера. */
export function normalizeCode(value: string): string {
  return value.replace(/\D/g, '').slice(0, CODE_LENGTH);
}

export function isCompleteCode(value: string): boolean {
  return /^\d{6}$/.test(value);
}
